import { render, staticRenderFns } from "./ThgBatchDetailInformationPayoutCard.vue?vue&type=template&id=dc5620e4&"
import script from "./ThgBatchDetailInformationPayoutCard.vue?vue&type=script&lang=ts&"
export * from "./ThgBatchDetailInformationPayoutCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
